import _implicitStylesheets from "./filterSearch.css";
import _implicitScopedStylesheets from "./filterSearch.scoped.css?scoped=true";
import _axIcon from "ax/icon";
import _wdsAnalyticsInstrument from "wds/analyticsInstrument";
import _axIconInteractive from "ax/iconInteractive";
import {freezeTemplate, parseFragment, registerTemplate} from "lwc";
const $fragment1 = parseFragment`<div class="message-box${0}"${2}><span${3}>${"t2"}</span></div>`;
const stc0 = {
  "role": "search"
};
const stc1 = {
  classMap: {
    "search-icon-container": true
  },
  key: 1
};
const stc2 = {
  props: {
    "type": "filter"
  },
  key: 3
};
const stc3 = {
  "bar-input": true
};
const stc4 = {
  "close-icon-container": true
};
const stc5 = {
  "tabindex": "0"
};
function tmpl($api, $cmp, $slotset, $ctx) {
  const {ncls: api_normalize_class_name, c: api_custom_element, h: api_element, gid: api_scoped_id, b: api_bind, d: api_dynamic_text, sp: api_static_part, st: api_static_fragment} = $api;
  const {_m0, _m1} = $ctx;
  return [api_element("div", {
    className: api_normalize_class_name($cmp.containerClass),
    attrs: stc0,
    key: 0
  }, [api_element("div", stc1, [api_custom_element("ax-icon", _axIcon, {
    props: {
      "icon": "magnifier",
      "size": "small",
      "iconDescription": $cmp.labels.searchButton
    },
    key: 2
  })]), api_custom_element("wds-analytics-instrument", _wdsAnalyticsInstrument, stc2, [api_element("input", {
    classMap: stc3,
    attrs: {
      "type": "text",
      "placeholder": $cmp.labels.placeholder,
      "title": $cmp.labels.placeholder,
      "aria-label": $cmp.labels.placeholder,
      "aria-controls": api_scoped_id("search-options"),
      "role": "searchbox",
      "aria-autocomplete": "list",
      "aria-activedescendant": ""
    },
    props: {
      "value": $cmp.keyword
    },
    key: 4,
    on: {
      "input": _m0 || ($ctx._m0 = api_bind($cmp.handleTextInput))
    }
  })]), $cmp.keyword ? api_element("div", {
    classMap: stc4,
    attrs: stc5,
    key: 5,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.handleClearSearch))
    }
  }, [api_element("div", {
    attrs: {
      "aria-label": $cmp.labels.clearSearchTerm
    },
    key: 6
  }, [api_custom_element("ax-icon-interactive", _axIconInteractive, {
    props: {
      "icon": "close",
      "size": "xsmall",
      "ariaLabel": $cmp.labels.clearSearchTerm,
      "ariaLive": "polite"
    },
    key: 7
  })])]) : null]), !$cmp.showfilters ? api_static_fragment($fragment1, 9, [api_static_part(2, null, api_dynamic_text($cmp.labels.noFiltersFound))]) : null];
  /*LWC compiler v7.1.3*/
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];
tmpl.stylesheetToken = "lwc-6lns7sde6o9";
tmpl.legacyStylesheetToken = "undefined-_filterSearch";
if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets);
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets);
}
freezeTemplate(tmpl);
